import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const bookingsContainersQueryAtom = createQueryAtomFactory(
  'trade.bookingsByIds',
  (params: { ids: string[] }) => ({
    bookings: {
      __args: {
        filter: {
          ids: params.ids,
        },
        pagination: {
          limit: params.ids.length,
          offset: 0,
        },
      },
      entries: {
        id: true,
        containers: {
          containerType: {
            id: true,
            name: true,
          },
          quantity: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.bookings.entries ?? [],
  },
);
